<div class="container mt-4">
  <h2>Eventos de Hazelcast (SSE)</h2>
  <div class="form-group">
    <label for="hazelcastLogs">Log en vivo:</label>
    <textarea 
      #logArea
      id="hazelcastLogs" 
      class="form-control" 
      rows="15" 
      readonly
      [value]="logs"
      style="font-family: monospace; background-color: #f8f9fa;">
    </textarea>
  </div>
</div>
